import http from 'axios';
import { API_URL } from '../runtimeConfig';

const PendingOrdersService = () => {
    const getPendingOrders = async (page, pageSize) => {
        let url = API_URL + '/shop/pendingOrders?';

        //if(page) {
            url += `&page=${page}&`;
        //}
        if(pageSize) {
            url += `pageSize=${pageSize}&`;
        }
        
        try {
            const res = await http.get(url);
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    const getPendingOrderLines = async (orderId) => {
        let url = API_URL + `/shop/pendingOrders/${orderId}/lines`;

        try {
            const res = await http.get(url);
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    const printPinkSheet = async (orderId) => {
        let url =  `https://mtsnstorage.blob.core.windows.net/fitterapp-pdf/salesOrder-${orderId}.pdf`;
    
        const link = document.createElement('a');
        link.href = url;
        link.download = `salesOrder-${orderId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return { getPendingOrders, getPendingOrderLines, printPinkSheet };

}

export default PendingOrdersService;